<Title date="2024-11-21" slug="patreon-migration">
  Migration: from Patreon to Demos
</Title>

This guide explains how current Patreon supporters can migrate to Demos and what to expect during the transition (Read here for the full article: [Leaving Patreon. Moving to Demos](/articles/leaving-patreon)).

Currently, I have 4 different subscription plans on Patreon:

- Supporter (4.5 USD/month): 184 users
- Supporter Pro (6.5 USD/month): 33 users
- Investor (15 USD/month): 6 users
- Enthusiast (50 USD/month): 1 user (you are my hero)

These options will be condensed into the Monthly Supporter plan.

If you are currently a Patreon supporter (as of November 20th, 2024), you will have the option to migrate to the Monthly Supporter plan at $4.5 USD/month (instead of $8 USD/month) for the first three months.

Additionally, you will have the option to migrate to the Annual Supporter plan at $50 USD/year for the first year instead of $60 USD/year.

The discounts will be automatically applied on the new platform after connecting your Patreon account (as it currently works on Reanimate.dev).

## What if you have purchased the Yearly Plan on Patreon?

There are currently ~20 people who have purchased the Yearly Plan on Patreon (since there were no real benefits from it).

Most likely, I'll handle the migration manually for this specific use case.

If you are among them, I'll DM you via Patreon after the launch (or you can DM me on [X](https://x.com/reactiive_)).

The options will be:

1. Create a discount that will give free access to the Monthly Supporter plan for N months (depending on how many months you have left from your annual subscription)
2. Annual Supporter plan discount based on the number of months left from your annual subscription
3. Full refund (if you have started the annual subscription less than 4 months ago)

## Did you purchase Reanimate.dev by signing in with Patreon?

No worries! You will still have access to Reanimate.dev by signing in with Patreon. In short, nothing will change.

## What will happen to the current [Patreon account](https://www.patreon.com/reactiive)?

I'll keep the current Patreon account with all the old posts and perks without updating them, but I won't publish any new posts on Patreon.

## Questions or feedback?

You can always DM me directly on [Patreon](https://www.patreon.com/reactiive_) or [X](https://x.com/reactiive_).
